// WORKPLACE DETAIL BY NAME ******************************************************************************
// pathname: /v1/workplace-detail-by-name
// *******************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/**
 * @description SWR: Get workplace detail by name, not slug.
 * @param locale - string, the locale
 * @param successCallback - function, the success callback
 * @param errorCallback - function, the error callback
 */
export const useSwrWorkplaceDetailByName = (
  locale = 'ro',
  successCallback?: (response: ApiSchema<'WorkplaceProfile2'>) => void,
  errorCallback?: (errors: ApiSchema<'ErrorResponse'>) => void,
) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'WorkplaceProfile2'>, ApiRequestBody<'/v1/workplace-detail-by-name', 'post'>>({
    url: '/v1/workplace-detail-by-name',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (response) => {
        // Callback
        if (successCallback) successCallback(response);
      },
      onError: (errorResponse) => {
        // Callback
        if (errorCallback) errorCallback(errorResponse);
      },
    },
    toastsOptions: {
      showErrorToast: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
